// extracted by mini-css-extract-plugin
export default {"contentTopParagraph":"Collections_contentTopParagraph__n0khq","fullBleedFlushLeft":"Collections_fullBleedFlushLeft__gNceq","fullBleed":"Collections_fullBleed__JJcvj"};